  

<template>
  <div :class="`outer-wrap `">
    <div :class="`wrap ${isMobile ? 'mobile' : ''}`">
      <!-- <h4
        class="outer-ui btn loading"
        v-show="!assetsLoaded"
        style="text-align: right"
      >
        Loading Scene...
      </h4> -->
      <!-- <div class="loader-wrap" v-if="!assetsLoaded">
        <div class="loader"></div>
        <p>Loading</p>
      </div> -->
      <button
        class="outer-ui btn"
        @click.stop="$emit('closewelcome')"
        style="text-align: right"
      >
        <img src="/icons/close dark 72.svg" alt />
      </button>
      <button
        class="outer-ui screen-size btn"
        @click="$emit('fullscreen')"
        style="text-align: right"
      >
        <img
          :src="`/icons/${!isFullScreen ? 'full screen' : 'mini screen'}.svg`"
          alt
        />
        <div class="suggestion">click for fullscreen</div>
      </button>

      <!-- <img class="welcome-img" src="/img/full_welcome_img.jpg" alt="" /> -->
      <div class="inner-wrap">
        <div class="side-a">
          <img class="logo" src="/img/logo-globe.png" alt />
          <div class="text-wrap">
            <div class="welcome-txt">
              <p class="light">WELCOME TO</p>
              <p class="heavy">Globe 3D Store</p>
            </div>
            <p class="quote light">
              No matter the challenge, we always have what it takes to overcome
              - to rebuild today and reshape tomorrow.
            </p>
          </div>

          <!-- <p class="huge-text">explore</p> -->
        </div>
        <div v-if="!isMobile" class="controls">
          <p class="txt">
            Use the keyboards to navigate and use the mouse to control the
            orbit.
          </p>
          <img src="/icons/welcomeControls.svg" alt />
        </div>
        <div v-else class="controls">
          <!-- <div class="forward">forward</div>
          <div class="backward">backward</div>
          <div class="left">left</div>
          <div class="right">right</div> -->
          <p class="txt">
            To move around touch the screen and drag the joystick to the required
            direction, touch to control the orbit.
          </p>
          <img src="/icons/welcomeStick.svg" alt />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/*eslint-disable */
export default {
  name: "Welcome",
  components: {},
  props: ["assetsLoaded", "isWelcome"],
  data: function () {
    return {
      isFullScreen: false,
      isMobile: false,
      event: {},
      // ifOrbiting: 10,
      // specifications: [],
      // currentModel: this.selectedPhone,
      // selectedMemory: null,
      // featured: true,
      // plans: [599, 999, 323],
      // currentPlan: 0,
      // memory: samsungGalaxyA51.product.variants.color[0].intenal_memory,
    };
  },
  methods: {
    closeUi: function () {},

    loaded: function () {},
  },
  created: function () {},
  mounted: function () {
    if (AFRAME.utils.device.isMobile()) {
      this.isMobile = true;
    }
  },
  computed: {},
};
</script>

<style scoped lang="scss">
.outer-wrap.loading {
  background-color: var(--yellow);
}
p {
  margin: 0;
}
.wrap {
  background-image: url("/img/welcome_img.jpg");
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
  box-shadow: inset 300px 0 200px #0000002f;
  @media (orientation: portrait) {
    background-position: 30% 80%; /* Center the image */
    background-size: cover; /* Resize the background image to cover the entire container */
  }
}
.welcome-img {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
// }
.wrap {
  position: absolute;
  overflow: hidden;
  padding-top: 55px;
  padding-left: 55px;
  text-align: left;
  height: 85%;
  width: 100%;
  max-width: 1400px;
  max-height: 934px;
  background-color: rgb(204, 204, 11);
  display: flex;
  justify-content: space-between;
  // position: relative;
  @media screen and (max-width: 1500px) {
    height: 90%;
    width: 90%;
  }
  &.mobile {
    height: 90%;
    width: 80%;
    padding: 20px;
    margin: 0px;
    @media (orientation: landscape) {
      height: 80%;
      width: 90%;
    }
  }
  .outer-ui {
    position: absolute;
    top: 29px;
    right: 29px;
  }
}
.inner-wrap {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.mobile {
  .inner-wrap {
    @media (orientation: portrait) {
      flex-direction: column;
    }
  }
}
.side-a {
  width: 505px;
  color: white;
  z-index: 5;
  .welcome-txt {
    letter-spacing: 0px;
    font-size: 70px !important;
    margin-bottom: 30px;
    @media screen and (max-height: 990px) {
      font-size: 50px;
    }
  }
  .quote {
    font-size: 34px;
    @media screen and (max-height: 990px) {
      font-size: 28px;
    }
  }
  .logo {
    margin-bottom: 50px;
    @media screen and (max-height: 1100px) {
      margin-bottom: 20px;
      width: 210px;
    }
  }
}
.mobile {
  .side-a {
    // max-width: 500px;
    // width: 100%;
    // display: flex;
  }
  .outer-ui {
    top: 30px;
    right: 30px;
  }
  .logo {
    margin-right: 70px;
    width: 165px;
    height: 62px;
    @media (orientation: landscape) {
      margin-bottom: 5px;
      flex-direction: column;
    }
  }
  .welcome-txt {
    font-size: 35px !important;
    margin-bottom: 10px;
  }
  .quote {
    font-size: 21px !important;
    font-weight: bolder;
    max-width: 329px;
    width: 100%;
    @media (orientation: landscape) {
      max-width: 319px;

      font-size: 18px !important;
    }
    // padding: 0 0px;
  }
}

.main-txt {
  font-size: 20px;
  font-weight: 700;
}
.sub-txt {
  font-size: 18px;
}

.huge-text {
  left: 50px;
  bottom: 15%;
  position: absolute;
  padding: 0;
  text-align: center !important;
  font-size: 400px;
  line-height: 100px;
  color: var(--yellow);
  text-shadow: 1px 1px 50px #00000050;
  user-select: none; /* Standard */

  z-index: -1;
}
.mobile {
  .huge-text {
    font-size: 226px;
    @media (orientation: portrait) {
      font-size: 100px;
    }
  }
}

.controls {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  margin-top: 130px;
  margin-right: 50px;
  border-radius: 50px;
  padding: 20px;
  user-select: none;
  img {
    width: 400px;
  }
  .txt {
    text-align: center;
    // position: absolute;
    width: 100%;
    max-width: 700px;
    color: white;
    font-weight: 900;
    left: -400px;
    top: -120px;
    font-size: 40px;
    // background-color: rgba(255, 255, 255, 0.192);
    border-radius: 20px;
    padding: 20px;
  }
}
.mobile {
  .controls {
    // position: absolute;
    width: 80vw;

    margin: 0;
    margin-bottom: 30px;
    align-self: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @media (orientation: landscape) {
      width: 300px;

      margin-bottom: 0px;
      align-self: flex-end;
      padding-bottom: 0;
      margin-bottom: 0;
      margin-right: 30px;
    }
    img {
      width: 100px;
    }
    .txt {
      font-size: 22px;
      padding: 0 20px;
      @media (orientation: landscape) {
        font-size: 18px;
      }
    }
  }
}
.orbit {
  width: 100%;
  height: 75%;
}
.outer-ui {
  left: unset;
  right: 50px !important;
}
.screen-size {
  top: 110px !important;
  position: relative;
  .suggestion {
    position: absolute;
    top: 26px;
    left: -130px;
    padding: 7px;
    background: rgba(255, 255, 255, 0.541);
    border-radius: 8px;
    font-size: 15px;
    color: var(--dark-blue);
    @media (orientation: portrait) {
      display: none;
    }
  }
}
.the-plan-txt {
  font-size: 70px;
  text-align: center;
  margin-bottom: 50px;
}

.details-slide {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 40px;
  a {
    font-size: 18px;
    color: #009ee6;
    position: relative;
    top: 5px;
  }
}

.btn-spec {
  cursor: pointer;
  width: 120px;
  height: 40px;
  border-radius: 13px;
  color: #009ee6;
  border: 2px solid #009ee6;
  border-radius: 20px;
  font-weight: 600;
  &:first-of-type {
    margin-right: 10px;
  }
  &:hover:not(.selected) {
    background: #009de609;
    // color: white;
  }
  &.selected {
    background: #009ee6;
    color: white;
  }
}
.outer-wrap {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 5;
  background-color: hsla(0, 0%, 16%, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
}
.mobile {
  .outer-ui {
    right: 10px !important;
      top: 10px !important;

    img {
      width: 60px;
      height: 60px;
    }
    &.screen-size {
      top: 70px !important;
    }
  }
  .suggestion {
    display: none;
  }
}
</style>
